import type { Values } from "@karrotmarket-com/type-utility";

export const WebSocketReadyState = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
} as const;

export const SocketStatus = {
  INITIAL: "INITIAL",
  CONNECTING: "CONNECTING",
  OPEN: "OPEN",
  CLOSING: "CLOSING",
  CLOSED: "CLOSED",
} as const;
export type SocketStatusType = Values<typeof SocketStatus>;

export const CloseEventReason = {
  UNSPECIFIED: "UNSPECIFIED",
  NORMAL: "NORMAL",
  SERVICE_RESTART: "SERVICE_RESTART",
  UNAUTHORIZED: "UNAUTHORIZED",
} as const;
export type CloseEventReasonType = Values<typeof CloseEventReason>;

export const SocketStatusMap = {
  [WebSocketReadyState.CONNECTING]: SocketStatus.CONNECTING,
  [WebSocketReadyState.OPEN]: SocketStatus.OPEN,
  [WebSocketReadyState.CLOSING]: SocketStatus.CLOSING,
  [WebSocketReadyState.CLOSED]: SocketStatus.CLOSED,
} as const;

export const WebSocketCloseCodes = {
  /**
   * @description 1000은 연결이 정상적으로 종료되었음을 나타냅니다.
   */
  CLOSE_NORMAL: 1000,
  /**
   * @description 1001은 서버가 다운되거나 사용자가 페이지를 이동하는 등의 이유로 endpoint가 "떠나고 있음"을 나타냅니다.
   */
  CLOSE_GOING_AWAY: 1001,
  /**
   * @description 1002는 프로토콜 오류로 인해 endpoint가 연결을 종료하고 있음을 나타냅니다.
   */
  CLOSE_PROTOCOL_ERROR: 1002,
  /**
   * @description 1003은 endpoint가 수신한 데이터 유형을 수용할 수 없어 연결을 종료하고 있음을 나타냅니다.
   */
  CLOSE_UNSUPPORTED: 1003,
  // 1004는 예약된 값으로, 특정 의미는 미래에 정의될 수 있습니다.
  /**
   * @description 1005는 예약된 값으로, 실제 상태 코드가 없는 것을 나타내기 위해 사용됩니다.
   */
  CLOSED_NO_STATUS: 1005,
  /**
   * @description 1006은 비정상적으로 연결이 종료되었음을 나타내기 위해 사용됩니다.
   */
  CLOSE_ABNORMAL: 1006, // 1006은 비정상적으로 연결이 종료되었음을 나타내기 위해 사용됩니다.
  /**
   * @description 1007은 메시지의 데이터 유형이 일치하지 않아 endpoint가 연결을 종료하고 있음을 나타냅니다.
   */
  UNSUPPORTED_PAYLOAD: 1007,
  /**
   * @description 1008은 정책 위반으로 인해 endpoint가 연결을 종료하고 있음을 나타냅니다.
   */
  POLICY_VIOLATION: 1008,
  /**
   * @description 1009는 처리할 수 없을 정도로 큰 메시지를 수신하여 endpoint가 연결을 종료하고 있음을 나타냅니다.
   */
  CLOSE_TOO_LARGE: 1009,
  /**
   * @description 1010은 클라이언트가 서버에서 특정 확장을 기대했으나 협상되지 않아 연결을 종료하고 있음을 나타냅니다.
   */
  MANDATORY_EXTENSION: 1010,
  /**
   * @description 1011은 서버가 예기치 않은 상황을 만나 요청을 처리할 수 없어서 연결을 종료하고 있음을 나타냅니다.
   */
  SERVER_ERROR: 1011,
  /**
   * @description 1012는 서버 또는 서비스가 재시작하고 있음을 나타냅니다.
   */
  SERVICE_RESTART: 1012,
  /**
   * @description 1013은 임시 서버 조건으로 인해 클라이언트의 요청이 차단되었음을 나타냅니다.
   */
  TRY_AGAIN_LATER: 1013,
  /**
   * @description 1014는 게이트웨이 역할을 하는 서버가 잘못된 응답을 수신했음을 나타냅니다.
   */
  BAD_GATEWAY: 1014,
  /**
   * @description 1015는 TLS 핸드셰이크 실패로 인해 연결이 종료되었음을 나타냅니다.
   */
  TLS_HANDSHAKE_FAIL: 1015,
} as const;
